import type { ComponentProps } from 'react'
import AnalyzerResults from '@/app/(app)/tools/robots-txt-analyzer/components/AnalyzerResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `robots` (Phase 3, Step 11 — Class B,
 * dashboard-reuse). This REPLACES the legacy inline `robots` branch that lived
 * in `ToolDetailPanel` (a thin bot-name/status grid).
 *
 * REUSES the public `AnalyzerResults` with `variant="dashboard"`, which hides
 * the public-only chrome (the email-share row, PlatformCTA, and the gradient
 * services CTA). The platform route (`/api/platform/tools/robots-analyzer`)
 * runs the same lib and returns the same `RobotsAnalyzerResult`, so the
 * dashboard `data` maps straight onto the component — the dashboard now shows
 * the full rich report (score ring + status badges, AI analysis, the bot-rules
 * table with its category sections, the score-breakdown cards using the
 * API-provided colors/details, the directive breakdown of user-agent blocks,
 * syntax issues with severity + line numbers, the suggested snippet with copy,
 * recommendations, and the raw robots.txt) instead of the generic panel.
 *
 * Wrapped in `id="tool-detail-panel"` so the dashboard scroll-to-panel still
 * works. Grade comes from `data.grade` via the reused component — never
 * recomputed; the deleted generic deriveBreakdown is NOT reintroduced (the
 * reused renderer owns the breakdown). Render-layer only.
 */
export function RobotsDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<
    typeof AnalyzerResults
  >['result']
  return (
    <div
      id='tool-detail-panel'
      className='rounded-xl border border-border bg-card p-5'
    >
      <AnalyzerResults result={result} variant='dashboard' />
    </div>
  )
}
